// Function for a element (button / link) .btnFixed
// element fixed to bottom and changes the position if the content is scrolled below the bottom border
// Warning! On the page there can be only one such button

(function() {
	document.addEventListener("DOMContentLoaded", function() {
		
		var button = document.getElementsByClassName("btnFixed")[0];
		var table;
		var windowHeight;
		var buttonHeight;
		var bottomTable;

		if(button) {
			toRelative();
			document.addEventListener("scroll", toRelative);
		}

		function toRelative() {
			table        = button.previousElementSibling;
			windowHeight = document.documentElement.clientHeight;
			buttonHeight = button.getBoundingClientRect().height;
			bottomTable  = table.getBoundingClientRect().bottom;

			if( (windowHeight - buttonHeight) >= bottomTable ) button.style.position = "relative";
			else button.style.position = "";
		};
		
	});
})();
